export function isHeicFile(file: File): boolean {
  return (
    file.type === 'image/heic' ||
    file.type === 'image/heif' ||
    file.name.toLowerCase().endsWith('.heic') ||
    file.name.toLowerCase().endsWith('.heif')
  )
}

export async function convertHeicToJpeg(file: File): Promise<File> {
  if (!isHeicFile(file)) {
    return file
  }

  try {
    // Dynamic import for better bundling - using heic-to (more up-to-date libheif)
    const { heicTo } = await import('heic-to')

    const blob = await heicTo({
      blob: file,
      type: 'image/jpeg',
      quality: 0.85,
    })

    // Create new File with JPEG extension
    const newFileName = file.name.replace(/\.(heic|heif)$/i, '.jpg')
    return new File([blob], newFileName, { type: 'image/jpeg' })
  } catch (error: unknown) {
    console.error('HEIC conversion failed:', error)
    throw new Error('Could not convert HEIC image. Please convert to JPEG before uploading.')
  }
}
